import { Tabs, Form, Input, InputNumber, Switch, Upload, Button, Row, Col, Space, Card, Popconfirm, Select, Tooltip, Divider } from 'antd';
import React, { useEffect, useState } from 'react';
import { ArrowLeftOutlined, InfoCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { navigate } from '../../../navigation';
import { ProductServices } from '../../Services/ProductServices';
import { notify } from '../../customs/NotifyProvider';
import { useLocation } from 'react-router-dom';
import { formatDateTime } from '../Customs/formatDateTime';
import { ENDPOINTS } from '../../Services/ENDPOINTS';
import { AddonServices } from '../../Services/AddonServices';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';


const AddVehicle = () => {
  const [form] = Form.useForm();
  const col = { xs: 24, sm: 12, md: 8 };
  const { Option } = Select;
  const [carDetails, setCarDetails] = useState({});
  const [data, setData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [addonId, setAddOnId] = useState([]);
  const [serviceId, setServiceId] = useState([]);
  const location = useLocation();
  const { id } = location.state || {};
  const [serviceType, setServiceType] = useState('');
  const isEdit = id !== undefined && id !== null;
  const [additionalPrices, setAdditionalPrices] = useState([]);
  const [selectedMediaImage, setSelectedMediaImage] = useState(null); // FIX: renamed from selectMediaImage
  const [mediaImages, setMediaImages] = useState([]);

  const getEditValues = async () => {
    try {
      const request = await ProductServices.getCarDetialById(id);
      if (request?.status && request?.data) {
        setCarDetails(request.data);
        const { addon_services, service_category, ...otherData } = request.data;
        const formValues = {
          ...otherData,
          driver_allowance_included: request?.data?.driver_allowance_included === "true",
          new_car_promise: request?.data?.new_car_promise === "true",
          car_image: request.data.upload_img
            ? [
              {
                uid: "-1",
                name: request.data.upload_img,
                status: "done",
                url: `${ENDPOINTS.cleanBase}${request.data.upload_img}`,
              },
            ]
            : [],
          addon_services: [],
          service_type: request.data.service_type,
          rental_type: request.data.rental_type,
          service_category: [],
        };

        setServiceType(request.data.service_type);
        form.setFieldsValue(formValues);
        const prices = request.data.additional_prices;

        if (prices) {
          try {
            const parsedPrices = Array.isArray(prices)
              ? prices
              : JSON.parse(prices);

            setAdditionalPrices(
              parsedPrices.map(item => ({
                type: item.type || null,
                name: item.name || "",
                amount: item.amount || "",
                from_time: item.from_time || "",
                to_time: item.to_time || ""
              }))
            );
          } catch (err) {
            console.error("Invalid additional_prices format", err);
          }
        }
      } else {
        notify.error("Something went wrong", request?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAddonServices = async () => {
    try {
      const request = await AddonServices.getAllAddonServices();
      setData(request.data);
    } catch (error) {
      console.error(error);
    }
  };

  const addPriceBlock = () => {
    setAdditionalPrices(prev => [
      ...prev,
      {
        type: null,
        name: "",
        amount: "",
        from_time: "",
        to_time: ""
      }
    ]);
  };

  const updatePriceBlock = (index, key, value) => {
    const updated = [...additionalPrices];
    updated[index][key] = value;
    setAdditionalPrices(updated);
  };

  const removePriceBlock = (index) => {
    setAdditionalPrices(prev => prev.filter((_, i) => i !== index));
  };

  const getServices = async () => {
    try {
      const request = await AddonServices.getAllServices();
      const safeData = Array.isArray(request?.data) ? request.data : [];
      setServiceData(safeData);
    } catch (error) {
      console.error(error);
      setServiceData([]);
    }
  };

  const handleChange = (selected) => {
    const ids = selected.map(item => item.value);
    setAddOnId(ids);
  };

  const parseTime = (time) => {
    if (!time) return null;
    return dayjs(time, "hh:mm A", true);
  };

  const handleServiceChange = (selected) => {
    const ids = selected.map(item => item.value);
    setServiceId(ids);
  };

  const getAllCarImage = async () => {
    try {
      const request = await ProductServices.getAllCarImage();
      setMediaImages(request.files);
    } catch (error) {
      console.error("Error fetching car images:", error);
    }
  };

  // FIX: Proper media library image selection handler
  const handleSelectMediaImage = (img) => {
    setSelectedMediaImage(img);

    // Build a fileList-compatible entry so the Upload component shows the selected image
    const mediaFile = {
      uid: `media-${img.url}`,
      name: img.url.split("/").pop(),
      status: "done",
      url: `${ENDPOINTS.IMAGE_BASE}${img.url}`,
      isMediaLibrary: true,   // custom flag to distinguish from real uploads
      mediaPath: img.url,     // the path we'll send to the backend
    };

    form.setFieldsValue({ car_image: [mediaFile] });
    notify.success("Image Selected", "Media image has been attached to the vehicle.");
  };

  useEffect(() => {
    if (isEdit && carDetails.addon_services && data.length > 0) {
      const ids = carDetails.addon_services
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
        .map(Number);
      const validIds = ids.filter(id => data.some(d => Number(d.id) === id));
      setAddOnId(validIds);
      const addonMap = new Map(data.map(d => [Number(d.id), d.name]));
      const options = validIds.map(id => ({
        value: id,
        label: addonMap.get(id),
      }));
      form.setFieldsValue({ addon_services: options });
    }
  }, [carDetails, data, isEdit]);

  useEffect(() => {
    if (isEdit && carDetails.service_category && serviceData.length > 0) {
      const ids = carDetails.service_category
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
        .map(Number);
      const validIds = ids.filter(id => serviceData.some(s => Number(s.id) === id));
      setServiceId(validIds);
      const serviceMap = new Map(serviceData.map(s => [Number(s.id), s.name]));
      const options = validIds.map(id => ({
        value: id,
        label: serviceMap.get(id),
      }));
      form.setFieldsValue({ service_category: options });
    }
  }, [carDetails, serviceData, isEdit]);

  useEffect(() => {
    if (isEdit) {
      getEditValues();
    }
  }, [id]);

  useEffect(() => {
    getAddonServices();
    getServices();
    getAllCarImage();
  }, []);

  const handleDeleteImage = async (image) => {
    const baseUrl = ENDPOINTS.asset_url;
    if (!image.startsWith(baseUrl)) {
      console.error("Invalid URL, does not match base path");
      return;
    }

    const fileName = image.split("/").pop();

    try {
      let response = await ProductServices.deleteUploadedFile({
        file_path: 'assets/cars',
        file_name: fileName
      });
      if (response.status) {
        const payload = {
          upload_img: '',
          updated_on: formatDateTime()
        };
        response = await ProductServices.updateCarDetails(id, payload);
      } else {
        notify.warning("warning", response.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async () => {
    try {
      const baseUrl = "/assets/cars/";
      const uploadImg = carDetails.upload_img || "";
      let fileName = "";
      if (uploadImg) {
        fileName = uploadImg.replace(baseUrl, "").split("?")[0];
      }
      if (fileName) {
        const response = await ProductServices.deleteUploadedFile({
          file_path: 'assets/cars',
          file_name: fileName
        });
        if (!response) {
          console.warn("File deletion failed, but continuing to delete car record.");
        }
      }
      const req = await ProductServices.deleteCarDetialById(id);
      if (req.status) {
        notify.success("Success", req.message);
        navigate('/manage-vehicle');
      } else {
        notify.error("Something went wrong", req.message);
      }
    } catch (error) {
      console.error("Error deleting car:", error);
    }
  };

  const onFinish = async (values) => {
    try {
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
        if (key === "car_image" || key === "addon_services" || key === "service_category") return;
        if (value === null || value === undefined || value === "") return;
        formData.append(key, value);
      });

      formData.append("additional_prices", JSON.stringify(additionalPrices));
      formData.append("added_by", null);
      formData.append("added_on", isEdit ? carDetails?.added_on : formatDateTime());
      formData.append("updated_on", formatDateTime());
      formData.append("status", "Active");

      if (addonId.length > 0) {
        formData.append("addon_services", addonId.join(','));
      }
      if (serviceId.length > 0) {
        formData.append("service_category", serviceId.join(','));
      }

      // FIX: Handle both media library selection and direct file upload
      if (values.car_image && values.car_image.length > 0) {
        const file = values.car_image[0];
        if (file.isMediaLibrary) {
          // Media library selection — send the path string directly
          formData.append("upload_img", file.mediaPath);
        } else if (file.originFileObj) {
          // Normal upload — send the actual file
          formData.append("upload_img", file.originFileObj);
        }
        // If neither (existing unchanged image in edit mode), skip — backend keeps existing value
      }

      let response;
      if (isEdit) {
        response = await ProductServices.updateCarDetails(id, formData);
      } else {
        response = await ProductServices.addCarDetails(formData);
      }

      if (response?.status) {
        notify.success("Success", response?.message);
        if (!isEdit && response?.data?.id) {
          navigate("/edit-vehicle", { state: { id: response.data.id } });
        }
      } else {
        notify.error("Something went wrong", response?.message);
      }
    } catch (error) {
      console.error(error);
      notify.error("Error", "Failed to submit");
    }
  };

  const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList;
  };

  return (
    <Card
      title={
        <Space>
          {isEdit ? (
            <>
              <ArrowLeftOutlined onClick={() => navigate('/manage-vehicle')} />
              Edit Vehicle
            </>
          ) : (
            <>
              <ArrowLeftOutlined onClick={() => navigate(-1)} />
              Create New Vehicle
            </>
          )}
        </Space>
      }
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflowY: "auto",
        paddingBottom: 16
      }}
      actions={[
        <div style={{ width: "100%", textAlign: "right", paddingRight: '20px' }}>
          <Space>
            {isEdit ? (
              <Popconfirm
                title="Are you sure to delete?"
                onConfirm={() => handleDelete()}
              >
                <Button danger>Delete</Button>
              </Popconfirm>
            ) : (
              <></>
            )}
            <Button type="primary" onClick={() => form.submit()}>
              {isEdit ? "Update Vehicle" : "Add New Vehicle"}
            </Button>
          </Space>
        </div>
      ]}
    >
      <Form layout="vertical" form={form} onFinish={onFinish} className="mt-4">
        <Tabs tabPosition="left" style={{ minHeight: 400 }}>

          {/* TAB 1 — Car Basic Details */}
          <Tabs.TabPane tab="Car Basic Details" key="1">
            <Row gutter={16}>
              <Divider>Service Type</Divider>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="service_type"
                  label="Select Service Type"
                  rules={[{ required: true, message: "Please select service type" }]}
                >
                  <Select
                    placeholder="Select service type(s)"
                    allowClear
                    onChange={(option) => { setServiceType(option); }}
                  >
                    <Select.Option value="rental">Rental</Select.Option>
                    <Select.Option value="airport">Airport</Select.Option>
                    <Select.Option value="outstation">Outstation</Select.Option>
                  </Select>
                </Form.Item>
              </Col>

              {serviceType === "rental" && (
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="rental_type"
                    label="Rental Type"
                    rules={[{ required: true, message: "Please select rental type" }]}
                  >
                    <Select placeholder="Select rental type(s)" allowClear>
                      <Select.Option value="4">4 Hours</Select.Option>
                      <Select.Option value="6">6 Hours</Select.Option>
                      <Select.Option value="8">8 Hours</Select.Option>
                      <Select.Option value="10">10 Hours</Select.Option>
                      <Select.Option value="12">12 Hours</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              )}

              {serviceType === "outstation" && (
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    name="rental_type"
                    label="Drop Type"
                    rules={[{ required: true, message: "Please select drop type" }]}
                  >
                    <Select placeholder="Select drop type" allowClear>
                      <Select.Option value="premium">Premium Drop</Select.Option>
                      <Select.Option value="regular">Regular Drop</Select.Option>
                      <Select.Option value="round">Round Trip</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              )}

              <Divider>Car Details</Divider>
              <Col {...col}>
                <Form.Item name="car_name" label="Car Name" rules={[{ required: true }]}>
                  <Input placeholder="Ertiga, Innova" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="car_type" label="Car Type">
                  <Input placeholder="Sedan / SUV" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="brand" label="Brand / Company">
                  <Input style={{ width: "100%" }} placeholder="Brand or company name" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={16}>
                <Form.Item name="service_category" label="Service Category">
                  <Select
                    mode="multiple"
                    placeholder="Select Special Service"
                    optionLabelProp="label"
                    onChange={handleServiceChange}
                    labelInValue
                  >
                    {serviceData.map((item) => (
                      <Option key={item.id} value={item.id} label={item.name}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <span>{item.name}</span>
                          <span style={{ fontSize: 12, color: "#888" }}>{item.description}</span>
                        </div>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="car_spec" label="Car Specifications">
                  <Input style={{ width: "100%" }} placeholder="AC/ Non-AC" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="gear_type" label="Gear Type">
                  <Input style={{ width: "100%" }} placeholder="Manual / Automatic" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="fule_type" label="Fuel type">
                  <Input style={{ width: "100%" }} placeholder="Petrol / Diesel" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="seater" label="No. of seater">
                  <Input style={{ width: "100%" }} placeholder="5" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="max_age_to_drive" label="Max. age to drive">
                  <Input style={{ width: "100%" }} placeholder="18+" />
                </Form.Item>
              </Col>
            </Row>
          </Tabs.TabPane>

          {/* TAB 2 — Rating */}
          <Tabs.TabPane tab="Rating" key="2">
            <Row gutter={16}>
              <Col {...col}>
                <Form.Item
                  name="rating"
                  label="Rating Value"
                  initialValue={4.9}
                  rules={[
                    { type: "number", min: 1, max: 5, message: "Rating must be between 1 and 5" },
                    {
                      validator: (_, value) => {
                        if (value === undefined) return Promise.resolve();
                        const decimalCheck = /^\d(\.\d)?$|^5(\.0)?$/;
                        return decimalCheck.test(value.toString())
                          ? Promise.resolve()
                          : Promise.reject(new Error("Only 1 decimal place allowed"));
                      },
                    },
                  ]}
                >
                  <InputNumber style={{ width: "100%" }} placeholder="4.8" min={1} max={5} />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="rating_count" label="Rating Count">
                  <InputNumber style={{ width: "100%" }} placeholder="230" />
                </Form.Item>
              </Col>
            </Row>
          </Tabs.TabPane>

          {/* TAB 3 — Pricing & Distance */}
          <Tabs.TabPane tab="Pricing & Distance" key="3">
            <Row gutter={16}>
              <Col {...col}>
                <Form.Item name="display_price" label="Display Price (₹)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: "100%" }} placeholder="3873" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="discount_percent" label="Discount %">
                  <InputNumber style={{ width: "100%" }} placeholder="10" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="min_travel_range_km" label="Included KMs" rules={[{ required: true }]}>
                  <InputNumber style={{ width: "100%" }} placeholder="253" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="additional_travel_amount" label="Additional Charge / KM">
                  <InputNumber style={{ width: "100%" }} placeholder="13.75" step={0.1} />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="additional_travel_amount_per_hr" label="Additional Charge / Hour">
                  <InputNumber style={{ width: "100%" }} placeholder="13.75" step={0.1} />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="toll_and_taxes" label="Toll & Taxes (₹)">
                  <InputNumber style={{ width: "100%" }} placeholder="485" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="rental_price_per_hr" label="Rental Price Per Hour (₹)">
                  <InputNumber style={{ width: "100%" }} placeholder="485" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="rental_price_per_day" label="Rental Price Per Day (₹)">
                  <InputNumber style={{ width: "100%" }} placeholder="485" />
                </Form.Item>
              </Col>
              <Col {...col}>
                <Form.Item name="driver_bata" label="Driver Bata (₹)">
                  <InputNumber style={{ width: "100%" }} placeholder="485" />
                </Form.Item>
              </Col>
            </Row>
          </Tabs.TabPane>

          {/* TAB 4 — Additional Price */}
          <Tabs.TabPane tab="Additional Price" key="4">
            <Button type="dashed" onClick={addPriceBlock}>
              + Add Additional Price
            </Button>

            {additionalPrices.map((item, index) => (
              <Card
                key={index}
                size="small"
                style={{ marginTop: 16 }}
                extra={
                  <Button danger size="small" onClick={() => removePriceBlock(index)}>
                    Remove
                  </Button>
                }
              >
                <Row gutter={16}>
                  <Col {...col}>
                    <Form.Item label="Additional Price Type" required>
                      <Select
                        placeholder="Select type"
                        value={item.type}
                        onChange={(value) => updatePriceBlock(index, "type", value)}
                      >
                        <Select.Option value="per_car">Per Car</Select.Option>
                        <Select.Option value="per_time">Per Time</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  {item.type === "per_car" && (
                    <>
                      <Col {...col}>
                        <Form.Item label="Price Name">
                          <Input
                            placeholder="Extra KM / Night charge"
                            value={item.name}
                            onChange={e => updatePriceBlock(index, "name", e.target.value)}
                          />
                        </Form.Item>
                      </Col>
                      <Col {...col}>
                        <Form.Item label="Amount (₹)">
                          <InputNumber
                            style={{ width: "100%" }}
                            value={item.amount}
                            onChange={value => updatePriceBlock(index, "amount", value)}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}

                  {item.type === "per_time" && (
                    <>
                      <Col {...col}>
                        <Form.Item label="From Time">
                          <TimePicker
                            use12Hours
                            format="hh:mm A"
                            style={{ width: "100%" }}
                            value={parseTime(item.from_time)}
                            onChange={(time, timeString) => {
                              updatePriceBlock(index, "from_time", timeString ?? "");
                            }}
                            allowClear
                            placeholder="Select from time"
                          />
                        </Form.Item>
                      </Col>
                      <Col {...col}>
                        <Form.Item label="To Time">
                          <TimePicker
                            use12Hours
                            format="hh:mm A"
                            style={{ width: "100%" }}
                            value={parseTime(item.to_time)}
                            onChange={(time, timeString) =>
                              updatePriceBlock(index, "to_time", timeString || "")
                            }
                            allowClear
                            placeholder="Select to time"
                          />
                        </Form.Item>
                      </Col>
                      <Col {...col}>
                        <Form.Item label="Price Name">
                          <Input
                            placeholder="Night Time Charge"
                            value={item.name}
                            onChange={e => updatePriceBlock(index, "name", e.target.value)}
                          />
                        </Form.Item>
                      </Col>
                      <Col {...col}>
                        <Form.Item label="Amount (₹)">
                          <InputNumber
                            style={{ width: "100%" }}
                            value={item.amount}
                            onChange={value => updatePriceBlock(index, "amount", value)}
                          />
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </Card>
            ))}
          </Tabs.TabPane>

          {/* TAB 6 — Descriptions */}
          <Tabs.TabPane tab="Descriptions" key="6">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="description"
                  label={
                    <Space>
                      Terms and Conditions&nbsp;
                      <Tooltip title="Separate each point using |">
                        <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                      </Tooltip>
                    </Space>
                  }
                  rules={[{ required: true }]}
                >
                  <Input.TextArea rows={4} placeholder="Full details" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="inclusion"
                  label={
                    <Space>
                      Inclusions&nbsp;
                      <Tooltip title="Separate each point using |">
                        <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                      </Tooltip>
                    </Space>
                  }
                >
                  <Input.TextArea rows={4} placeholder="Enter Inclusions" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="exclusion"
                  label={
                    <Space>
                      Exclusions&nbsp;
                      <Tooltip title="Separate each point using |">
                        <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                      </Tooltip>
                    </Space>
                  }
                >
                  <Input.TextArea rows={4} placeholder="Enter Exclusions" />
                </Form.Item>
              </Col>
            </Row>
          </Tabs.TabPane>

          {/* TAB 7 — Upload Image */}
          <Tabs.TabPane tab="Upload Image" key="7">
            <Tabs defaultActiveKey="1">

              {/* Upload Tab */}
              <Tabs.TabPane tab="Upload" key="1">
                <Row gutter={16}>
                  <Col {...col}>
                    <Form.Item
                      name="car_image"
                      label="Upload Car's Image"
                      valuePropName="fileList"
                      getValueFromEvent={normFile}
                    >
                      <Upload
                        beforeUpload={(file, fileList) => {
                          const currentFiles = form.getFieldValue("car_image") || [];
                          if (currentFiles.length > 0) {
                            notify.warning(
                              "Image already exists",
                              "To upload a new image, please delete the previous uploaded image first."
                            );
                            return Upload.LIST_IGNORE;
                          }
                          return false;
                        }}
                        listType="picture"
                        onChange={(info) => {
                          if (info.file.status === "removed") {
                            const url = info.file.url || info.file.thumbUrl;
                            if (url) handleDeleteImage(url);
                            // Also clear selected media image state if any
                            setSelectedMediaImage(null);
                          }
                        }}
                      >
                        <Button icon={<UploadOutlined />}>Upload</Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
              </Tabs.TabPane>

              {/* Media Library Tab */}
              <Tabs.TabPane tab="Media Library" key="2">
                <div style={{ height: "70vh", width: "100%", overflowY: "auto" }}>
                  <Row gutter={16}>
                    {mediaImages?.map((img, index) => (
                      <Col span={6} key={index} style={{ marginBottom: 16 }}>
                        {/* FIX: wrapper div handles click and selected styling */}
                        <div
                          style={{
                            position: "relative",
                            borderRadius: 8,
                            overflow: "hidden",
                            border: selectedMediaImage?.url === img.url
                              ? "3px solid #1890ff"
                              : "3px solid transparent",
                            cursor: "pointer",
                            transition: "border 0.2s",
                          }}
                          // FIX: call the proper handler instead of the state setter
                          onClick={() => handleSelectMediaImage(img)}
                        >
                          <img
                            src={`${ENDPOINTS.IMAGE_BASE}${img.url}`}
                            alt="media"
                            style={{
                              width: "100%",
                              display: "block",
                              borderRadius: 6,
                            }}
                          />
                          {/* FIX: "Selected" badge shown on chosen image */}
                          {selectedMediaImage?.url === img.url && (
                            <div
                              style={{
                                position: "absolute",
                                top: 6,
                                right: 6,
                                background: "#1890ff",
                                color: "#fff",
                                fontSize: 11,
                                fontWeight: 600,
                                padding: "2px 8px",
                                borderRadius: 4,
                              }}
                            >
                              Selected
                            </div>
                          )}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Tabs.TabPane>

            </Tabs>
          </Tabs.TabPane>

          {/* TAB 8 — Addon Services */}
          <Tabs.TabPane tab="Addon Services" key="8">
            <Space>
              <Form.Item label="Add addon Services" name="addon_services">
                <Select
                  mode="multiple"
                  style={{ width: 500 }}
                  placeholder="Select Special Service"
                  optionLabelProp="label"
                  onChange={handleChange}
                  labelInValue
                >
                  {data.map((item) => (
                    <Option key={item.id} value={item.id} label={item.name}>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span>{item.name}</span>
                        <span style={{ fontSize: 12, color: "#888" }}>{item.description}</span>
                      </div>
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Space>
          </Tabs.TabPane>

        </Tabs>
      </Form>
    </Card>
  );
};

export default AddVehicle;